import React from "react";

const TemplateTwo = () => {
    return <div>TemplateTwo</div>;
};

export default TemplateTwo;
